import React from "react";
import { SERVICE_AREAS } from "../lib/brand";
import { MapPin } from "lucide-react";

export default function ServiceArea() {
  return (
    <section id="areas" data-testid="areas-section" className="relative bg-[color:var(--dbe-cream)] py-16 sm:py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="relative">
          <div className="aspect-[5/4] rounded-[24px] sm:rounded-[32px] overflow-hidden shadow-[0_40px_80px_-30px_rgba(0,0,0,0.3)] border border-black/5">
            <iframe
              title="Dead Bug Edwards Service Area - Plantation, FL"
              src="https://www.google.com/maps?q=300%20S%20State%20Road%207%2C%20Plantation%2C%20FL%2033317&output=embed"
              className="w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-[color:var(--dbe-red)] text-white rounded-2xl px-5 sm:px-6 py-3 sm:py-4 shadow-xl">
            <div className="font-bebas text-2xl sm:text-3xl leading-none">HQ</div>
            <div className="text-[10px] sm:text-xs uppercase tracking-wider opacity-90">Plantation, FL</div>
          </div>
        </div>

        <div className="mt-6 lg:mt-0">
          <p className="text-[color:var(--dbe-red)] text-xs tracking-[0.35em] uppercase font-bold">Service Area</p>
          <h2 className="mt-3 sm:mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.02] font-bebas">
            Proudly protecting<br />
            <span className="text-[color:var(--dbe-red)]">South Florida.</span>
          </h2>
          <p className="mt-4 sm:mt-5 text-base sm:text-lg text-neutral-700 leading-relaxed max-w-xl">
            Based in Plantation, FL - we service homes, businesses and marinas across
            Broward, Miami-Dade and South Palm Beach counties.
          </p>

          <div className="mt-6 sm:mt-8 flex flex-wrap gap-2">
            {SERVICE_AREAS.map((a) => (
              <span
                key={a}
                className="inline-flex items-center gap-1.5 bg-white border border-black/10 text-neutral-800 text-xs sm:text-sm px-3 py-1.5 rounded-full"
              >
                <MapPin className="w-3.5 h-3.5 text-[color:var(--dbe-red)]" />
                {a}
              </span>
            ))}
          </div>

          <a
            href="#quote"
            data-testid="areas-cta"
            className="mt-6 sm:mt-8 inline-flex items-center gap-2 bg-[color:var(--dbe-black)] text-white px-6 py-3 rounded-full font-bold uppercase tracking-wider text-xs sm:text-sm hover:bg-[color:var(--dbe-red)] transition-colors"
          >
            Not sure? Ask us <i className="fa-solid fa-arrow-right text-xs" />
          </a>
        </div>
      </div>
    </section>
  );
}
